import { render, staticRenderFns } from "./QcqQualityStarsSelector.vue?vue&type=template&id=48e04b98&scoped=true&lang=pug&"
import script from "./QcqQualityStarsSelector.vue?vue&type=script&lang=ts&"
export * from "./QcqQualityStarsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./QcqQualityStarsSelector.vue?vue&type=style&index=0&id=48e04b98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e04b98",
  null
  
)

export default component.exports